import React from 'react';
import Alert from 'react-bootstrap/Alert';

// Alert Props
export interface AlertDialogProps {
    title: string,
    message: string,
}

export default function AlertDialog(p: AlertDialogProps): JSX.Element | null {
    return (
            <Alert variant="light">
                <Alert.Heading style={{ color: "#000000"}}>{p.title}</Alert.Heading>
                <p style={{ color: "#000000"}}>{p.message}</p>
            </Alert>
    );
}
